// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1Mv3H","collapse":"collapse__3h9Vx","content":"content__2hjeL","header":"header__1aa76","arrow":"arrow__83jXN","project":"project__k1B9O","picture":"picture__1Wpr7","title":"title__3qDPh","info":"info__X4zU9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Index/styles.scss
// module id = 264
// module chunks = 0